import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskJourneysRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-journeys',
	path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
	exact: true,
};
